import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.mobile = window.matchMedia("(max-width: 767px)")
    this.onViewportChange = () => this.close()
    this.mobile.addEventListener("change", this.onViewportChange)
    this.close()
    this.element.dataset.sidebarConnected = "true"
  }

  disconnect() {
    this.mobile.removeEventListener("change", this.onViewportChange)
    document.documentElement.classList.remove("sidebar-mobile-open")
  }

  toggle() {
    if (this.mobile.matches) {
      document.documentElement.classList.toggle("sidebar-mobile-open")
    } else {
      const collapsed = document.documentElement.classList.toggle("sidebar-collapsed")
      try { localStorage.setItem("sidebar-collapsed", collapsed ? "1" : "0") } catch (_) { /* Storage is optional. */ }
    }
    this.updateExpanded()
  }

  close() {
    document.documentElement.classList.remove("sidebar-mobile-open")
    this.updateExpanded()
  }

  updateExpanded() {
    const expanded = this.mobile.matches
      ? document.documentElement.classList.contains("sidebar-mobile-open")
      : !document.documentElement.classList.contains("sidebar-collapsed")
    this.element.querySelector('[aria-controls="app-sidebar"]')?.setAttribute("aria-expanded", String(expanded))
  }
}
